import { render, staticRenderFns } from "./ExpiredDocuments.vue?vue&type=template&id=1fde8390&"
import script from "./ExpiredDocuments.vue?vue&type=script&lang=js&"
export * from "./ExpiredDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports